import axios from 'axios'
import CryptoJS from 'crypto-js'
import Qs from 'qs'
import { Toast } from 'vant';
import Vue from 'vue'
import { EventBus } from './eventBus';
Vue.use(Toast);
// create an axios instance
import {
  Decrypt,
  Encrypt
} from "./crypt";
// const baseURL = "/delAccountApi";
const baseURL = "/api";


const service = axios.create({
	baseURL: baseURL,
	headers: {
		// 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
	},
	method: 'POST',
	responseType: 'json',
})

// request interceptor
service.interceptors.request.use(
	(config) => {
    config.data.mid = 15
    config.data.channel = -1
    console.log(config.data)

    var requestData = Encrypt(JSON.stringify(config.data))

    config.data = {
      data: requestData,
      encrypt: 2
    }
		return config
	},
	(error) => {
	
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

service.interceptors.response.use(
	(response) => {
    var res = ""
    var data = ""
	console.log(response.data.code)
    if(response.data.code==0){
      var res  = Decrypt(response.data.data)
      var data  = JSON.parse(res)
      return {
		data:data,
		code:response.data.code,
	  }
    }else{
		EventBus.$emit('showErrorModal', response.data.message || 'Unknown error');
		// Toast.fail(response.data.message || 'error');
		return false
	}
		console.log(response)
		
	},
	(error) => {
		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/request/axios.js